import { FC, PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';

const Portal: FC<PropsWithChildren> = (props) =>
  ReactDOM.createPortal(props.children, document.body);

export default Portal;
